define.alias("shared/helpers/is-active", "calendar/helpers/is-active");